import React from "react";
import { useRouter } from "next/router";

import useDomain from "../../hooks/useDomain";

export function ReportProblemMailer({
  wrapperClasses,
}: {
  wrapperClasses?: string;
}) {
  const { asPath } = useRouter();
  const domain = useDomain();

  const url = `${domain}${asPath}`;

  return (
    <div className={wrapperClasses}>
      Notice a problem?
      <a
        className="underline ml-xs"
        style={{ fontWeight: 600 }}
        href={`mailto:reportaconcern@leafly.com?subject=Report a concern&body=Reporting a concern with ${url}.`}
      >
        Report this item
      </a>
    </div>
  );
}

export default ReportProblemMailer;
